'use client'

import { Switch } from '@/components/ui/switch';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CookieCategoryInfo } from '@/lib/types/cookies';

interface CookieCategoryProps {
  category: CookieCategoryInfo;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

export default function CookieCategory({
  category,
  enabled,
  onToggle,
  disabled = false
}: CookieCategoryProps) {
  return (
    <Card className={`${disabled ? 'opacity-75' : ''}`}>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            {category.name}
            {category.required && (
              <Badge variant="secondary" className="text-xs">
                Required
              </Badge>
            )}
          </CardTitle>
          <Switch
            checked={enabled}
            onCheckedChange={onToggle}
            disabled={disabled || category.required}
          />
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <p className="text-sm text-muted-foreground mb-3">
          {category.description}
        </p>
        <div className="space-y-1">
          <p className="text-xs font-medium text-muted-foreground">Technologies:</p>
          <div className="flex flex-wrap gap-1">
            {category.technologies.map((tech, index) => (
              <Badge key={index} variant="outline" className="text-xs">
                {tech}
              </Badge>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}